// extracted by mini-css-extract-plugin
export default {"tooltip":"OQ-z","arrow":"PQ-z"};